import Vaff from './Vaff.js';
import VaffArrayField from './VaffArrayField.js';
import VaffArrayOfObjectField from './VaffArrayOfObjectField.js';
import VaffField from './VaffField/index.js';

export default {
	vaff: Vaff,
	vaffArrayField: VaffArrayField,
	vaffArrayOfObjectField: VaffArrayOfObjectField,
	vaffField: VaffField,
};
